import { render, staticRenderFns } from "./CourierSelect.vue?vue&type=template&id=6bb376b8&scoped=true&"
import script from "./CourierSelect.vue?vue&type=script&lang=js&"
export * from "./CourierSelect.vue?vue&type=script&lang=js&"
import style0 from "./CourierSelect.vue?vue&type=style&index=0&id=6bb376b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb376b8",
  null
  
)

export default component.exports